// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"337":"2d5e024c","453":"8701dc61","455":"4d7416d6"}[chunkId] + ".chunk.js";
};